var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-layout', {
    attrs: {
      "align-baseline": ""
    }
  }, [_vm.item.isHidden ? [_c('v-icon', {
    staticClass: "mr-8",
    attrs: {
      "small": "",
      "color": "grey-d"
    }
  }, [_vm._v("mdi-eye-off-outline")])] : _vm.item.isSecret ? [_c('v-icon', {
    staticClass: "mr-8",
    attrs: {
      "small": "",
      "color": "grey-d"
    }
  }, [_vm._v("mdi-lock-outline")])] : _vm._e(), _vm.item.isHidden && !_vm.isUserAuthorized ? [_c('span', {
    staticClass: "grey-9--text"
  }, [_vm._v(" 블라인드된 글입니다. ")])] : _vm.item.isSecret && !_vm.isUserAuthorized ? [_c('span', {
    staticClass: "grey-9--text"
  }, [_vm._v(" 비밀글입니다. ")])] : [_vm._v(" " + _vm._s(_vm.item.subject || "-"))]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }